export async function readBlobAsJSON(blob: Blob): Promise<any> {
  return JSON.parse(await blob.text());
}
